import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "./authSlice";
import toast from "react-hot-toast";
import ResetPasswortModal from "../../components/common/modals/ResetPasswortModal";
import { isEmail, isRequired } from "../../utils/validation";

export default function Main() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    const nextErrors = {};
    if (!isRequired(email)) nextErrors.email = "Bitte E-Mail eingeben.";
    else if (!isEmail(email))
      nextErrors.email = "Bitte eine gültige E-Mail-Adresse eingeben.";
    if (!isRequired(password)) nextErrors.password = "Bitte Passwort eingeben.";

    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    setLoading(true);

    const userData = {
      email,
      password,
    };

    dispatch(loginUser(userData))
      .then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          toast.success("Login erfolgreich");
          const payload = res.payload;
          const role = payload?.user?.role ?? payload?.role ?? "user";

          navigate(role === "admin" ? "/admin" : "/home", { replace: true });
        } else {
          const message =
            typeof res.payload === "string"
              ? res.payload
              : res.payload?.message || "Login fehlgeschlagen";

          toast.error(message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="kn-page">
      {loading && (
        <div className="fixed top-0 left-0 right-0 z-50">
          <div className="mx-2 mt-1 h-[2px] bg-gray-300 opacity-80 rounded-full animate-pulse" />
        </div>
      )}

      {resetPassword && (
        <div className="flex items-center justify-center gap-2">
          <ResetPasswortModal
            isOpen={resetPassword}
            onClose={() => setResetPassword(false)}
          />
        </div>
      )}

      <main className="flex justify-center px-6 pt-16 pb-20">
        <div className="w-full max-w-[440px]">
          <div className="kn-eyebrow">Konto</div>
          <h1 className="kn-h1 mt-3">Willkommen zurück</h1>

          <form
            onSubmit={handleLogin}
            className="mt-8 flex flex-col gap-[18px]"
            noValidate
          >
            <div>
              <label htmlFor="email" className="kn-field-label">
                E-Mail
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  className="kn-input mt-1.5"
                  placeholder="Email"
                  type="email"
                  id="email"
                  autoComplete="email"
                  aria-invalid={!!errors.email}
                />
              </label>
              {errors.email && (
                <p className="text-sm text-knapp-accent mt-1">{errors.email}</p>
              )}
            </div>

            <div>
              <label htmlFor="password" className="kn-field-label">
                Passwort
                <span className="mt-1.5 flex items-center rounded-[10px] border border-knapp-borderInput bg-white focus-within:border-knapp-ink transition-colors">
                  <input
                    onChange={(e) => setPassword(e.target.value)}
                    className="font-barlow text-base text-knapp-ink px-4 py-3 border-0 bg-transparent outline-none flex-1 min-w-0 placeholder:text-knapp-placeholder rounded-[10px]"
                    placeholder="Passwort"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    aria-invalid={!!errors.password}
                  />
                  <button
                    type="button"
                    className="border-0 bg-transparent text-sm font-semibold text-knapp-ink3 px-4 py-3 cursor-pointer whitespace-nowrap hover:text-knapp-ink"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={
                      showPassword ? "Passwort verbergen" : "Passwort anzeigen"
                    }
                    aria-pressed={showPassword}
                  >
                    {showPassword ? "Verbergen" : "Anzeigen"}
                  </button>
                </span>
              </label>
              {errors.password && (
                <p className="text-sm text-knapp-accent mt-1">
                  {errors.password}
                </p>
              )}
            </div>

            <div className="flex justify-end text-sm">
              <button
                type="button"
                onClick={() => setResetPassword(true)}
                className="font-semibold underline"
              >
                Passwort vergessen
              </button>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="kn-btn-primary mt-1.5 w-full py-[15px] text-base"
            >
              {loading ? "Login..." : "Login"}
            </button>
          </form>

          <div className="mt-7 pt-5 border-t border-knapp-border text-[15px] text-knapp-ink2">
            Noch kein Konto?{" "}
            <Link to="/registrierung" className="font-semibold underline">
              Jetzt registrieren
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
